import { ToasterContainer } from "@inno-ui/toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.scss";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { BrowserRouter } from "react-router";

import App from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: Infinity,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_APP_RECAPTCHA_CLIENT_KEY}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ToasterContainer />
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  </StrictMode>,
);
